import { render, staticRenderFns } from "./resourceStoreUseRecordManageList.vue?vue&type=template&id=5a3e0cca&scoped=true"
import script from "./resourceStoreUseRecordManageList.vue?vue&type=script&lang=js"
export * from "./resourceStoreUseRecordManageList.vue?vue&type=script&lang=js"
import style0 from "./resourceStoreUseRecordManageList.vue?vue&type=style&index=0&id=5a3e0cca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3e0cca",
  null
  
)

export default component.exports